/* eslint-disable sort-keys */
export const CONTENT_MODE = {
  PREVIEW: 'preview',
  PRESENT: 'present',
  TEACHER_PRESENT: 'teacher_present',
  ASSESS: 'assess',
  REVIEW: 'review',
  TEACHER_REVIEW_AS_STUDENT: 'teacher_review'
};
